import to from 'await-to-js';
import OKA from '../';

export default {
    RequestOTPFromWidget: (phone, type, facilityId) => new Promise(async(resolve, reject) => {
        if (!OKA.http.account) reject(false);
        if (phone) {
            const [err, response] = await to(OKA.http.account.post('/patient/otp', {
                phone,
                filter: `${facilityId}`,
                type
            }));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('phone not found'))
    }),
    CreateAppointmentFromWidget: (data) => new Promise(async(resolve, reject) => {
        if (!OKA.http.account) reject(false);
        const [err, response] = await to(OKA.http.account.post('/patient/appointment', {
            ...data
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    VerifyAndLoginByPhone: (data) => new Promise(async(resolve, reject) => {
        if (!OKA.http.account) reject(false);
        const [err, response] = await to(OKA.http.account.post('/patient/verify', {
            ...data
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    
    GetAppointments: (facilityId, status, upcoming, token) => new Promise(async(resolve, reject) => {
        if (!OKA.http.account) reject(false);
        const [err, response] = await to(OKA.http.account.get('/patient/appointment', {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                facility_id: facilityId,
                status,
                upcoming
            }
        }));

        if (err) {
            reject(err)
        }

        resolve(response);
    })

};